import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import type { RecordModel } from 'pocketbase'
import { pb } from '../services/pocketbase'

export const useAuthStore = defineStore('auth', () => {
  const record = ref<RecordModel | null>(pb.authStore.record)
  const initialized = ref(false)
  const loading = ref(false)
  const error = ref('')

  const isAuthenticated = computed(
    () => Boolean(pb.authStore.isValid && record.value),
  )
  const username = computed(() => String(record.value?.username || ''))
  const nickname = computed(
    () =>
      String(record.value?.expand?.nickname?.display_name || '') ||
      String(record.value?.nickname_name || '') ||
      '匿名同学',
  )

  pb.authStore.onChange((_token, nextRecord) => {
    record.value = nextRecord
  })

  async function initialize() {
    if (initialized.value) return
    if (pb.authStore.isValid) {
      try {
        const auth = await pb.collection('users').authRefresh({
          expand: 'nickname',
        })
        record.value = auth.record
      } catch {
        pb.authStore.clear()
      }
    }
    initialized.value = true
  }

  async function login(identity: string, password: string) {
    loading.value = true
    error.value = ''
    try {
      const auth = await pb
        .collection('users')
        .authWithPassword(identity.trim().toUpperCase(), password, {
          expand: 'nickname',
        })
      record.value = auth.record
    } catch {
      error.value = '账号或密码不正确。请检查匿名账号是否完整。'
      throw new Error(error.value)
    } finally {
      loading.value = false
    }
  }

  function logout() {
    pb.authStore.clear()
    record.value = null
  }

  return {
    record,
    initialized,
    loading,
    error,
    isAuthenticated,
    username,
    nickname,
    initialize,
    login,
    logout,
  }
})

